// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wc9sRYyAq1t78QlGxNfR {
  display: flex;
  justify-content: center;
  align-items: center;
}

.WDa6iE1uyB76EhlaqJWh {
  display: flex;
  justify-content: left;
  align-items: center;
}

.LkTDK6LKQUbFwpVyVVlw {
  display: flex;
  justify-content: right;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/style/common.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".centered {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.left {\n  display: flex;\n  justify-content: left;\n  align-items: center;\n}\n\n.right {\n  display: flex;\n  justify-content: right;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centered": `Wc9sRYyAq1t78QlGxNfR`,
	"left": `WDa6iE1uyB76EhlaqJWh`,
	"right": `LkTDK6LKQUbFwpVyVVlw`
};
export default ___CSS_LOADER_EXPORT___;
